import React from "react";

const InspectionReport = () => {

    const reportData = {
        inspectionType: "M.V ROUTINE TEST REPORT",
        inspectionNumber: "INS-001"
    };

    const characteristics = [
        {
            characteristic: "HV Test at kV for Minutes",
            standardValue: "Withstand"
        },
        {
            characteristic: "PD Test at 1.73 Uo",
            standardValue: "pC"
        },
        {
            characteristic: "IR Test at 5-kV DC",
            standardValue: "MΩ"
        },
        {
            characteristic: "Capacitance",
            standardValue: "µF"
        }
    ];

    return (

        <div style={styles.page}>

            {/* HEADER */}

            <table style={styles.headerTable}>

                <tbody>

                    <tr>

                        <td style={styles.logoCell}>
                            <img
                                src="/logo.png"
                                alt="logo"
                                style={styles.logo}
                            />
                        </td>

                        <td style={styles.companyCell}>
                            SBEE CABLES (INDIA) LIMITED
                        </td>

                    </tr>

                </tbody>

            </table>

            {/* TITLE */}

            <div style={styles.title}>
                {reportData.inspectionType}
            </div>

            {/* DETAILS */}

            <table style={styles.detailsTable}>

                <tbody>

                    <tr>
                        <td>Type & Size :</td>
                        <td></td>

                        <td>W.O.No :</td>
                        <td></td>

                        <td>Dr.No :</td>
                        <td></td>
                    </tr>

                    <tr>
                        <td>Voltage Grade :</td>
                        <td></td>

                        <td>Customer Name :</td>
                        <td></td>

                        <td>Top(M) :</td>
                        <td></td>
                    </tr>

                    <tr>
                        <td>Specification :</td>
                        <td></td>

                        <td>Type :</td>
                        <td></td>

                        <td>Bottom(M) :</td>
                        <td></td>
                    </tr>

                    <tr>
                        <td>Temp :</td>
                        <td></td>

                        <td>Date of Testing :</td>
                        <td></td>

                        <td>Length(M) :</td>
                        <td></td>
                    </tr>

                    <tr>
                        <td></td>
                        <td></td>

                        <td>Drum No :</td>
                        <td></td>

                        <td></td>
                        <td></td>
                    </tr>

                </tbody>

            </table>

            {/* ELECTRICAL TESTS */}

            <table style={styles.mainTable}>

                <thead>

                    <tr>

                        <th rowSpan="2">
                            PARTICULARS
                        </th>

                        <th colSpan="3">
                            TEST RESULTS
                        </th>

                        <th rowSpan="2">
                            SPD.VALUE
                        </th>

                        <th rowSpan="2">
                            REMARKS
                        </th>

                    </tr>

                    <tr>

                        <th>RED</th>
                        <th>YELLOW</th>
                        <th>BLUE</th>

                    </tr>

                </thead>

                <tbody>

                    {characteristics.map((item, index) => (

                        <tr key={index}>

                            <td>
                                {item.characteristic}
                            </td>

                            <td></td>

                            <td></td>

                            <td></td>

                            <td>
                                {item.standardValue}
                            </td>

                            <td></td>

                        </tr>

                    ))}

                </tbody>

            </table>

            {/* FOOTER */}

            <table style={styles.footerTable}>

                <tbody>

                    <tr>

                        <td>
                            CHECKED BY
                        </td>

                        <td>
                            APPROVED BY
                        </td>

                    </tr>

                    <tr>

                        <td style={styles.signArea}>
                            NAME
                        </td>

                        <td style={styles.signArea}>
                            NAME
                        </td>

                    </tr>

                    <tr>

                        <td>
                            DESIGNATION
                        </td>

                        <td>
                            DESIGNATION
                        </td>

                    </tr>

                </tbody>

            </table>

            <div style={styles.inspectionNo}>

                Inspection Number :
                {" "}
                {reportData.inspectionNumber}

            </div>

            <div style={{ marginTop: 20 }}>

                <button
                    onClick={() => window.print()}
                >
                    Download PDF
                </button>

            </div>

        </div>
    );
};

const styles = {

    page: {
        width: "1000px",
        margin: "auto",
        background: "#fff",
        padding: "20px",
        color: "#000"
    },

    headerTable: {
        width: "100%",
        borderCollapse: "collapse"
    },

    logoCell: {
        width: "180px",
        border: "1px solid #000"
    },

    companyCell: {
        border: "1px solid #000",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "30px"
    },

    logo: {
        width: "120px"
    },

    title: {
        border: "1px solid #000",
        borderTop: "none",
        textAlign: "center",
        fontWeight: "bold",
        padding: "8px",
        textDecoration: "underline"
    },

    detailsTable: {
        width: "100%",
        borderCollapse: "collapse"
    },

    mainTable: {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "10px"
    },

    footerTable: {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "30px"
    },

    signArea: {
        height: "80px"
    },

    inspectionNo: {
        marginTop: "20px",
        textAlign: "right",
        fontWeight: "bold"
    }
};

Object.values(styles).forEach(() => {});

export default InspectionReport;